export default __webpack_public_path__ + "static/media/manFloating@2x.e8dc0aac.png";